import { LOAN_TYPE_BUSINESS } from "@/lib/constants";
import { useFormDataStore } from "@/components/context/useFormContext";
import { BusinessLoanDetails } from "@/components/forms/parts/business/loanDetailsStep";
import { DefaultLoanDetails } from "@/components/forms/parts/default/loanDetailsStep";

export const LoanDetails = () => {
	const { formValues } = useFormDataStore();

	return (
		<div className="eL-space-y-2">
			{formValues.loanType !== LOAN_TYPE_BUSINESS ? (
				<>
					{/* Other Loan Types*/}
					<DefaultLoanDetails />
				</>
			) : (
				<>
					{/* Business Loan */}
					<BusinessLoanDetails />
				</>
			)}
		</div>
	);
};
